// extracted by mini-css-extract-plugin
export default {"seo-data":"_2LIeo","seoData":"_2LIeo"};